/**
 * Number display settings panel for banner editor
 */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";
import { GOOGLE_FONTS } from "./constants";

export function NumberSettings({ banner, setBanner, numberSets = [] }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <Label className="text-xs text-gray-400 uppercase tracking-wider">Number Images</Label>
        <Switch
          checked={banner.use_number_images}
          onCheckedChange={(checked) => setBanner({ ...banner, use_number_images: checked })}
          data-testid="use-images-toggle"
          className="scale-75"
        />
      </div>
      
      {banner.use_number_images ? (
        <div>
          <select
            value={banner.number_set_id || ""}
            onChange={(e) => setBanner({ ...banner, number_set_id: e.target.value || null })}
            className="w-full h-9 px-3 rounded-lg bg-[#1a1a24] border border-white/10 text-sm text-white"
          >
            <option value="">Default Number Set</option>
            {numberSets.map(set => (
              <option key={set.id} value={set.id}>{set.name}</option>
            ))}
          </select>
          <p className="text-xs text-gray-600 mt-1">
            Manage sets in Number Assets
          </p>
        </div>
      ) : (
        <div className="space-y-3 p-3 bg-white/5 rounded-lg">
          <div>
            <Label className="text-xs text-gray-500">Font</Label>
            <select
              value={banner.number_text_font}
              onChange={(e) => setBanner({ ...banner, number_text_font: e.target.value })}
              className="w-full mt-1 h-8 px-2 rounded bg-[#1a1a24] border border-white/10 text-xs text-white"
            >
              {GOOGLE_FONTS.map(font => (
                <option key={font} value={font}>{font}</option>
              ))}
            </select>
          </div>
          
          <div>
            <Label className="text-xs text-gray-500">Size: {banner.number_text_size}px</Label>
            <Slider
              value={[banner.number_text_size]}
              onValueChange={([value]) => setBanner({ ...banner, number_text_size: value })}
              min={12}
              max={80}
              step={1}
              className="mt-2"
            />
          </div>
          
          <div>
            <Label className="text-xs text-gray-500">Color</Label>
            <div className="flex gap-2 mt-1">
              <input
                type="color"
                value={banner.number_text_color}
                onChange={(e) => setBanner({ ...banner, number_text_color: e.target.value })}
                className="w-8 h-8 rounded cursor-pointer border-0"
              />
              <Input
                value={banner.number_text_color}
                onChange={(e) => setBanner({ ...banner, number_text_color: e.target.value })}
                className="flex-1 h-8 bg-[#1a1a24] border-white/10 text-white font-mono text-xs"
              />
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Switch
              checked={banner.number_text_shadow}
              onCheckedChange={(checked) => setBanner({ ...banner, number_text_shadow: checked })}
              className="scale-75"
            />
            <Label className="text-xs text-gray-400">Drop Shadow</Label>
          </div>
        </div>
      )}
    </div>
  );
}
